import React, { useState, useEffect, useRef, useContext } from "react";
import styles from "../../../../../pages/dashboard/CourseCategory.module.css";
import style from "../HomePage/StudyMaterial.module.css";
import red_undeline from "../../../../../img/dashboard/Red Underline (1).png";
import separator_pattern_right from "../../../../../img/dashboard/Bottom Separator Pattern - Right (1).png";
import separator_pattern_left from "../../../../../img/dashboard/Bottom Separator Pattern - Left (1).png";
import { Link, useNavigate, useParams } from "react-router-dom";
import CardTemplate from "../CardTemplate";
import PaginationTop10 from "../../../../../pages/dashboard/PaginationTop10";
import { AxiosInstance } from "../../../../../axios";
import Loader from "../../../Loader";
import toast from "react-hot-toast";
import moment from "moment";
import { CartContext } from "../../../../../context/CartItems";
import { WishListContext } from "../../../../../context/WishListItems";
import { customStyles } from "../../../../../pages/customStyles";

const StudyMaterial = () => {
  const { id } = useParams(); // Extract category ID from route
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [medium, setMedium] = useState("");
  const [mediumName, setMediumName] = useState("");
  const [course, setCourse] = useState("");
  const [courseName, setCourseName] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [bookList, setBookList] = useState();
  const itemsPerPage = 8; // Items per page
  const [fullData, setFullData] = useState([]); // Initialize as empty array
  const [currentPage, setCurrentPage] = useState(0);
  const currentData =
    fullData.length > 0
      ? fullData.slice(
          currentPage * itemsPerPage,
          (currentPage + 1) * itemsPerPage
        )
      : [];

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    userid = user?.user_id || null;
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    loadListdata();
  }, []);

  const loadListdata = async () => {
    setIsLoading(true);
    try {
      const res = await AxiosInstance.post("/api/book/view_all_books", {
        user_id: userid,
        search: "",
        view_all_book: 1,
        popularity: 3, // default for best sellers
        category_id: "",
        group_course_id: "",
        subject_id: "",
        medium: "",
        is_set: "",
        tag_id: "",
        book_id: "",
        is_combo_offer: "",
        is_ebook: "",
        book_type: "",
      });
      if (res.data.status) {
        setFullData(res.data.data.slice(-24));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred while fetching data.");
    } finally {
      setIsLoading(false);
    }
  };

  // Pagination functions
  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(fullData.length / itemsPerPage) - 1) {
      setCurrentPage(currentPage + 1);
    }
  };
  const { cartNotify } = useContext(CartContext);
  const { WishNotify } = useContext(WishListContext);
  const toggleWishlist = (bookId, currentStatus) => {
    const payload = {
      user_id: userid,
      book_id: bookId,
      is_favorite: currentStatus == 1 ? 0 : 1, // Toggle is_favorite value
      created_by: userid,
      created_dt: moment().format("YYYY-MM-DD"),
    };

    AxiosInstance.post("/api/book/wishlist/add", payload)
      .then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          loadListdata();
          WishNotify(userid);
        } else {
          toast.error(res.data.message);
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((error) => {
        console.error("Error updating wishlist:", error);
      });
  };
  const handleAddCart = async (bookIds) => {
    try {
      const res = await AxiosInstance.post("/api/book/cart/add", {
        id: "",
        user_id: userid,
        book_id: bookIds,
        created_dt: moment().format("YYYY-MM-DD"),
        created_by: userid,
      });
      if (res.data.status) {
        toast.success(res.data.message);
        loadListdata();
        cartNotify(userid);
      } else {
        toast.error(res.data.message);
        sessionStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  };
  // Search state
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [sseriesName, setSeriesName] = useState("");
  const [sseriesvalue, setSseriesvalue] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");

  // Category Array
  const [categories, setCategories] = useState([]);
  const [courses, setCourses] = useState([]);

  // Medium Array
  const [mediums, setMediums] = useState([
    { id: "1", name: "English" },
    { id: "0", name: "Tamil" },
    { id: "2", name: "Both" },
  ]);

  // const [categoryIndex, setcategoryIndex] = useState(0);
  // const [rankHolderRes, setRankHolderRes] = useState([]);
  // Handle category change

  // Category API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await AxiosInstance.get("api/course/category_list");
        if (response.data.status) {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    fetchCourseList();
  }, [selectedCategory]);

  const fetchCourseList = async () => {
    try {
      const response = await AxiosInstance.get(
        `api/all/getCourses/${selectedCategoryName}/0`
      );
      if (response.data.status) {
        setCourses(response.data.data);
      } else {
        console.error("API returned an error:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching course list:", error);
    }
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedCategoryName(event.target.selectedOptions[0].text);
  };

  const handleChange = (e, namess) => {
    if (namess == "course_name") {
      setCourseName(e.target.selectedOptions[0].text);
      setCourse(e.target.value);
    } else if (namess == "medium_name") {
      setMediumName(e.target.selectedOptions[0].text);
      setMedium(e.target.value);
    } else {
      setSelectedValueName(e.target.selectedOptions[0].text);
      setSelectedValue(e.target.value);
    }
  };

  const seriesData = [
    {
      id: 0,
      seriesName: "A",
      seriesTitle: "A - Series Books",
      title: `Author Book Series - All Topics, One Book!`,
      description: `The comprehensive designed by expert faculties of our Academy to cover the entire 
syllabus.`,
    },
    {
      id: 1,
      seriesName: "B",
      seriesTitle: "B - Series Books",
      title: `Text Book Series -`,
      description: `A comprehensive book covering all essential 
topics of the syllabus from 6th to 12th Standard for respective 
subjects, making perfect companion for revision, learning and 
success.`,
    },
    {
      id: 2,
      seriesName: "GB",
      seriesTitle: "General Books",
      title: `Reference Book Series -`,
      description: `It is a collection of standard reference 
books for each subject by famous authors, providing invaluable 
companion for achieving success.`,
    },
    {
      id: 3,
      seriesName: "QB",
      seriesTitle: "AIASA Question Bank",
      title: `Question Bank Series -`,
      description: `This bank contains collection of thousands 
of topic wise questions for each subject curated by expert faculties of 
our Academy, covering complete syllabus for testing yourself as a 
track to success.`,
    },
    {
      id: 4,
      seriesName: "PYQ",
      seriesTitle: "TNPSC Previous Year Question Papers",
      title: `PYQ Bank Series -`,
      description: `A collection of thousands of questions from 
previous years’ question papers, compiled as subject wise books,
giving you a clear view of topic wise analysis.`,
    },
  ];
  const handleViewAllbooksnav = () => {
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        categoryId: selectedCategory,
        category_name: selectedCategoryName,
        course_name: courseName,
        medium_name: mediumName,
        courseId: course,
        mediumId: medium,
        search: searchText,
        series_value: "",
        series_name: "",
      },
    });
  };

  const handleGetSeries = (id, namess) => {
    setSearchText("");
    setSelectedCategory("");
    setCourse("");
    setMedium("");
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        // categoryId: selectedCategory,
        // category_name: selectedCategoryName,
        // course_name: courseName,
        // medium_name: mediumName,
        // courseId: course,
        // mediumId: medium,
        // search: searchText,
        series_value: id,
        series_name: namess,
      },
    });
  };

  const [selectedTags, setSelectedTags] = useState([]);

  const handleTagsFilter = (id, tagName) => {
    const newTag = [{ id, name: tagName, type: "selectedTags" }];
    setSelectedTags(newTag);
    navigate("/studyMaterials/Books/ViewAllBook", {
      state: {
        categoryId: selectedCategory,
        category_name: selectedCategoryName,
        course_name: courseName,
        medium_name: mediumName,
        courseId: course,
        mediumId: medium,
        search: searchText,
        series_value: "",
        SELECTEDTAGS: newTag,
      },
    });
  };

  return (
    <div className="studyMaterial my-5">
      <div className="m-lg-4 m-3">
        <h3 className={`${styles.courseTitle} text-center position-relative`}>
          Your Success Starts with the R
          <span>
            <img
              className={`${styles.course_underline_img}`}
              src={red_undeline}
              alt="word_underline"
            />
          </span>
          ight Book
        </h3>
        <p className={`${styles.subtitle}`}>
          Filter by category, course and medium to find exactly what you need.
        </p>

        <div
          className={`${style.searchBooks} d-flex flex-wrap  justify-content-evenly py-4 p-lg-2 my-4`}
        >
          {/* ----Search---- */}
          <div
            className={`${style.borderedEnter_vr} ${style.searchInput} d-flex align-items-center`}
          >
            <span onClick={handleViewAllbooksnav} className="material-icons">
              search
            </span>
            <input
              placeholder="Enter Book Names/Subjects"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleViewAllbooksnav();
                }
              }}
              className={`${style.no_focus} w-100`}
            />
          </div>
          {/* ----Select Category---- */}
          <div className={`${style.bordered_vr}`}>
            <select
              className={`${styles.custom_width} ${styles.dropdownarrow_img} ${styles.select} ${style.select} form-select w-100 cursorPnt`}
              onChange={handleCategoryChange}
              value={selectedCategory}
            >
              <option value="" hidden className="cursorPnt">
                {categories.length > 0
                  ? "Select Category"
                  : "No category available"}
              </option>
              {categories.map((category) => (
                <option
                  className="cursorPnt"
                  key={category.id}
                  value={category.id}
                  name={category.name}
                >
                  {category.name}
                </option>
              ))}
            </select>
          </div>
          {/* ----Select Course---- */}
          <div className={`${style.bordered_vr} col-md-2`}>
            {/* <select
              className={`${styles.custom_width} ${styles.dropdownarrow_img} ${styles.select} ${style.select} form-select w-100`}
              value={selectedValue}
              onChange={handleChange}
            >
              <option value="" hidden>
                Select Course
              </option>
              {courses.map((course) => (
                <option key={course.id} value={course.course_name}>
                  {course.course_name}
                </option>
              ))}
            </select> */}

            <select
              className={`${styles.custom_width} ${styles.dropdownarrow_img} ${styles.select} ${style.select} form-select w-100`}
              onChange={(e) => handleChange(e, "course_name")}
              value={course}
            >
              <option value="" hidden>
                {courses.length > 0 ? "Select Course" : "Select Course"}
              </option>
              {courses.map((course) => (
                <option
                  key={course.id}
                  value={course.id}
                  name={course.course_name}
                >
                  {course.course_name}
                </option>
              ))}
            </select>
          </div>
          {/* ----Select Medium---- */}
          <div className={style.bordered_vr}>
            <select
              className={`${styles.custom_width} ${styles.dropdownarrow_img} ${styles.select} ${style.select} form-select w-100`}
              value={medium}
              onChange={(e) => handleChange(e, "medium_name")}
            >
              <option value="" hidden>
                Select Medium
              </option>
              {mediums.map((medium) => (
                <option key={medium.id} value={medium.id} name={medium.name}>
                  {medium.name}
                </option>
              ))}
            </select>
          </div>
          {/* ---Submit Button ----*/}
          <div className="row mx-0 p-0">
            <div className="px-0 col-xl-12 col-lg-12 col-md-12 col-12 ">
              <Link
                to="javascript:void(0)"
                onClick={handleViewAllbooksnav}
                className={`primaryButton text-center ${style.fullWidthSearchBtn}  `}
                variant="primary"
              >
                Search Books
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* separator image */}
      <div
        className={`${styles.separator_pattern_right} d-flex justify-content-end my-lg-5 my-4`}
      >
        <img
          src={separator_pattern_right}
          alt="separator_pattern_right"
          className={`${style.separator_pattern_right}`}
        />
      </div>
      {/* Group books */}
      <div className="m-lg-0 m-3">
        <h3 className={`${styles.courseTitle} text-center position-relative`}>
          Books Organized for E
          <span>
            <img
              className={`${styles.course_underline_img}`}
              src={red_undeline}
              alt="word_underline"
            />
          </span>
          asy Selection
        </h3>
        <p className={`${styles.subtitle}`}>
          Navigate through well-defined categories to find and purchase the
          right books for your exam success!
        </p>
        {/* series card portion */}
        <div
          className={`${style.seriesCard} row d-flex justify-content-evenly px-2 p-lg-0`}
        >
          {seriesData.map((series, index) => (
            <div
              key={index}
              className={`${style.seriesPortion} col-lg-2 col-12 p-0 mb-lg-0 mb-4 d-flex flex-column`}
            >
              <div className="d-flex justify-content-end">
                <span className={style.seriesName}>{series.seriesName}</span>
              </div>

              <div className={`${style.contentPortion} p-2 flex-grow-1`}>
                <p className={style.seriesTitle}>{series.seriesTitle}</p>
                <span className={`${style.descriptionValue} m-0 p-0`}>
                  <span style={{ fontWeight: 600 }}>{series.title}</span>{" "}
                  {series.description}
                </span>
              </div>

              <div className="mt-auto px-0">
                <Link
                  to="javascript:void(0)"
                  onClick={() => handleGetSeries(series.id, series.seriesName)}
                  className={`primaryButton text-center ${style.fullWidthButton}`}
                  variant="primary"
                >
                  View All Books
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* separator left image */}
      <div
        className={`${styles.separator_pattern_left} d-flex justify-content-start my-lg-5 my-4`}
      >
        <img
          src={separator_pattern_left}
          alt="separator_pattern_left"
          className={`${style.separator_pattern_right}`}
        />
      </div>
      {/* Best sellers */}
      <div className="m-lg-4 m-3">
        <h3 className={`${styles.courseTitle} text-center position-relative`}>
          Our B
          <span>
            <img
              className={`${styles.course_underline_img}`}
              src={red_undeline}
              alt="word_underline"
            />
          </span>
          estsellers
        </h3>
        <p className={`${styles.subtitle}`}>
          Top picks to boost your exam preparation. Don't miss out on the most
          popular books!
        </p>
        <div className={`row mx-0 mt-5`}>
          {currentData.length > 0 &&
            currentData.map((item, index) => (
              <div className="col-lg-3 col-12 mb-2" key={index}>
                <CardTemplate
                  items={item}
                  toggleWish={toggleWishlist}
                  handleSubmitCart={handleAddCart}
                  ///
                  tagsFilter={selectedTags}
                  handleTagsFilter={handleTagsFilter}
                />
              </div>
            ))}
        </div>
        {/* Pass showViewAllButton as true */}
        {currentData.length > 0 && (
          <PaginationTop10
            totCount={Array.from({
              length: Math.ceil(fullData.length / itemsPerPage),
            })}
            currentPage={currentPage}
            hPrev={handlePrev}
            hNext={handleNext}
            onPageChange={setCurrentPage}
            showViewAllButton={true} // Show the "View All Books" button here
          />
        )}

        {/* slide with previous and next portion */}
        {/* <div className="d-flex justify-content-between my-5">
          <div>Slide</div>
          <div>
            <Link
               to="javascript:void(0)"
                    onClick={handleViewAllbooksnav}
              className={style.primaryButton}
              variant="primary"
            >
              View All Books
            </Link>
          </div>
          <div>
            <PaginationTop10
              totCount={rankHolderRes}
              currentPage={categoryIndex}
            />
          </div>
        </div> */}
      </div>
      {/* separator image */}
      <div
        className={`${styles.separator_pattern_right} d-flex justify-content-end my-lg-5 my-4`}
      >
        <img
          src={separator_pattern_right}
          alt="separator_pattern_right"
          className={`${style.separator_pattern_right}`}
        />
      </div>
    </div>
  );
};

export default StudyMaterial;
